import { ThemeOptions } from '@mui/material';

export const tabThemeOptions: ThemeOptions = {
  components: {
    MuiTab: {
      styleOverrides: {
        root: {
          textTransform: 'none',
        },
      },
    },
  },
};
